import React, { useState, useEffect } from 'react'
import heroImg from '../../images/hero_img.png'

function Home() {
  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
  const titles = [
    'UI/UX Designer',
    'UI Developer',
    'Frontend Developer',
    'Frontend Designer',
    
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTitleIndex(prevIndex => (prevIndex + 1) % titles.length);
    }, 3000);

    return () => clearInterval(intervalId);
  }, [titles.length]);
  return (
    <main> <div className="hero  ml-72">
      <div className="main-hero-box ">
        <div className="left-box">
          <img src={heroImg} alt="" />
        </div>
        <div className="right-box">
          <h1 className="title">Hey there!</h1>
          <p className='detail-para'>My name is <span className='name'>Trapti Khandelwal</span></p>
          <h1 className="title profile-name">{titles[currentTitleIndex]}</h1>
          <p className='detail-para'> With nearly 6 years in UI development and the past 8 months focused exclusively on UI/UX design, I offer a hybrid skill set that combines aesthetic insight with technical execution. After mastering frontend technologies like ReactJS, Vue.js, JavaScript, and advanced CSS, I pursued the <b> Google UX Design Certificate</b> to deepen my understanding of user-centered design. Since January 2025, I’ve been working as a <b>UI/UX Design Intern</b>, collaborating on product flows, wireframes, and scalable design systems using Figma. My strength lies in bridging the gap between visual design and functional code — delivering intuitive, polished experiences users love.</p>
        </div>
      </div>
    </div></main>
  )
}

export default Home
